import type { App } from './App';

export class PrefersColorSchemeSubscription {
  private media: MediaQueryList;
  private app: App;

  constructor(app: App) {
    this.app = app;
    this.media = matchMedia('(prefers-color-scheme: dark)');
    this.handleChange();
    this.unsubscribe = this.subscribe();
  }

  private subscribe() {
    this.media.addEventListener('change', this.handleChange);
    return () => {
      this.media.removeEventListener('change', this.handleChange);
    };
  }

  unsubscribe: () => void;

  private handleChange = () => {
    document.documentElement.classList.toggle('global-theme-dark', this.media.matches); // Необходимо для корректной работы @sbol/nova.
    this.app.set_isDarkMode(this.media.matches);
  };
}
